import { ResourceType } from '../datasource/datasource.types';
import { logger } from '../utils';
import { FieldTypeEnum, TYPES_MAP } from './metadata.types';
/**
 * Converts the field definitions to field metadata.
 * @public
 * @param fieldDef - The field definitions.
 * @returns An array of field metadata.
 */
export const toFieldMetadata = (fieldDef) => {
    if (!fieldDef)
        return null;
    return fieldDef.map((field) => {
        const meta = {
            name: field.NAME,
            type: TYPES_MAP[field.TYPE] || FieldTypeEnum.STRING,
        };
        if (field.TYPE === FieldTypeEnum.ENUM && field.VALID_VALUES) {
            try {
                meta.enumOptions = Array.isArray(field.VALID_VALUES)
                    ? field.VALID_VALUES
                    : field.VALID_VALUES.split('|');
            }
            catch (err) {
                logger.error(err);
                meta.enumOptions = [];
            }
        }
        return meta;
    });
};
/**
 * Extracts the field definitions from the metadata.
 * @public
 * @param metadata - The metadata object.
 * @returns An array of metadata detail.
 */
export const extractFieldDefinitions = (metadata) => {
    const type = metadata === null || metadata === void 0 ? void 0 : metadata.TYPE;
    if (type === ResourceType.DATASERVER) {
        return metadata.FIELD || [];
    }
    if (type === ResourceType.REQUEST_SERVER) {
        return metadata.REPLY_FIELD || [];
    }
    throw new Error(`Unsupported resource type: ${type}`);
};
